export class FindingsSave {
  screeningID = "";
  selectedFindings = [];
  doctors = [];
  selectedImages = [];
  diagnosis = "";
  recommendation = "";
}
